import React from 'react';
import { ShareUrl } from '../../types/api';
import { BodyObject, CamelizedArticleResponse } from '../../types/api/article';
import { Container } from '../../components/Container';
import { DailyWagArticleAuthorBlock } from './components/DailyWagArticleAuthorBlock';
import { DailyWagArticleBodyContainer } from './components/DailyWagArticleBodyContainer';
import { DailyWagArticleBouncer } from './components/DailyWagArticleBouncer';
import { DailyWagArticleCommentSection } from './components/DailyWagArticleCommentSection';
import { DailyWagArticleHeader } from './components/DailyWagArticleHeader';
import { DailyWagArticleRelatedArticles } from './components/DailyWagArticleRelatedArticles';
import { DailyWagArticleSocialShareIcons } from './components/DailyWagArticleSocialShareIcons';
import { DailyWagHeroHeaderImage } from './components/DailyWagHeroHeaderImage';
import { JSONLD } from '../../components/JSONLD';
import { Grid } from '../../wag-react/core-components/grid';
import { Box } from '../../wag-react/next-components/box';
type Props = Pick<CamelizedArticleResponse, 'author' | 'readTime' | 'commentList' | 'relatedArticles'> & {
  body: Array<BodyObject>;
  heroImageUrl: string;
  shareUrls: Array<ShareUrl>;
  slug: string;
  structuredData: {
    article: unknown;
    videos: unknown[];
  };
  title: string;
};
export const DailyWagArticlePageContainer = ({
  author,
  body,
  heroImageUrl,
  title,
  slug,
  shareUrls,
  structuredData: {
    article,
    videos
  },
  readTime,
  relatedArticles,
  commentList
}: Props) => <>
    <Container maxWidth={['100%', '688px', '1000px', '1600px']} px={['unset', '16px', '24px']} data-sentry-element="Container" data-sentry-source-file="index.tsx">
      <Grid gridTemplateColumns={['1fr', '100px 1fr 100px', 'repeat(3, 1fr)']} my={['0px', '42px']} data-sentry-element="Grid" data-sentry-source-file="index.tsx">

        <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <DailyWagArticleSocialShareIcons display={['none', 'grid']} title={title} shareUrls={shareUrls} data-sentry-element="DailyWagArticleSocialShareIcons" data-sentry-source-file="index.tsx" />
        </Box>
        <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Box p={['16px', 'unset']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <DailyWagArticleHeader title={title} readTime={readTime} data-sentry-element="DailyWagArticleHeader" data-sentry-source-file="index.tsx" />
            <DailyWagArticleSocialShareIcons display={['grid', 'none']} position="unset" gridGap="0" title={title} shareUrls={shareUrls} data-sentry-element="DailyWagArticleSocialShareIcons" data-sentry-source-file="index.tsx" />
          </Box>
          <DailyWagHeroHeaderImage slug={slug} heroImageUrl={heroImageUrl} data-sentry-element="DailyWagHeroHeaderImage" data-sentry-source-file="index.tsx" />
          {author && <DailyWagArticleAuthorBlock value={author} />}
          <Box p={['16px', 'unset']} mt="32px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <DailyWagArticleBodyContainer body={body} data-sentry-element="DailyWagArticleBodyContainer" data-sentry-source-file="index.tsx" />
          </Box>
          <DailyWagArticleCommentSection slug={slug} {...commentList} data-sentry-element="DailyWagArticleCommentSection" data-sentry-source-file="index.tsx" />
        </Box>
      </Grid>
    </Container>
    <Container maxWidth={['375px', '688px', '1024px', '1600px']} data-sentry-element="Container" data-sentry-source-file="index.tsx">
      <DailyWagArticleRelatedArticles value={relatedArticles} data-sentry-element="DailyWagArticleRelatedArticles" data-sentry-source-file="index.tsx" />
    </Container>

    <DailyWagArticleBouncer slug={slug} data-sentry-element="DailyWagArticleBouncer" data-sentry-source-file="index.tsx" />

    {/* Structured Data for article */}
    <JSONLD data-sentry-element="JSONLD" data-sentry-source-file="index.tsx">
      {article}
    </JSONLD>

    {/* Structured Data for videos in article */}
    {videos && videos.map((video: {
    embedUrl: string;
  }) => <JSONLD key={video.embedUrl}>
          {video}
        </JSONLD>)}
  </>;